import { SelectOption } from '@globaleris/ui.library'
import { EnumIdioma } from '../../api'
import {
  PriceComponentTypeModel,
  PriceSummaryModel
} from '../../api/Argentia/endpoints/priceComponents'
import { Product } from '../../api/Argentia/endpoints/products/model/products'
import {
  ProductConceptModel,
  ProductModel,
  ProductTranslation
} from '../../api/Argentia/model/contracts'
import { EnumSubTipoConfiguracion } from '../../api/oData/enums/enumSubTipoConfiguracion'
import { EnumTipoConfiguracion } from '../../api/oData/enums/enumTipoConfiguracion'
import { EnumTipoRelacionProductoConcepto } from '../../api/oData/enums/enumTipoRelacionProductoConcepto'
import { enumKeyToValue } from '../../helpers'
import { NewContractProduct } from '../contracts/contracts.model'
import TemplateSettings from '../templateSettings/templateSettings.model'
import { ProductTranslationModel } from './edit/components/translationsCard/translationsCard.model'
import { ProductDetail, ProductsTableModel } from './products.Model'
import { ConceptModifiedModel } from '../../api/Argentia/endpoints/conceptsModified/model/conceptsModified'
import { EnumPriceType } from '../../api/oData/enums/enumPriceType'
import { EnumCommodity } from '../../api/Argentia/enums'

export const productsToProductTableListModelMapper = (product: Product[]): ProductsTableModel[] => {
  return product.map(product => productToProductTableModelMapper(product))
}

export const productToProductTableModelMapper = (product: Product): ProductsTableModel => {
  return {
    id: product.id,
    code: product.code,
    description: product.description,
    type: product.type,
    currency: product.currency,
    lgEnabled: product.lgEnabled,
    commodity: product.commodity,
    companyId: product.companyId,
    breakdownType: product.breakdownType,
    weightedType: product.weightedType,
    showDisableIcon: product.lgEnabled || product.lgEnabled == null ? true : false,
    showEnableIcon: product.lgEnabled || product.lgEnabled == null ? false : true
    // contractsCount: new Set(product.relatedContracts.map(contract => contract.id)).size
  }
}

export const mapProductModel = (newProduct: any): ProductModel => {
  return (
    newProduct && {
      id: newProduct.id,
      code: newProduct.code,
      description: newProduct.description,
      type: newProduct.type,
      currency: newProduct.currency,
      commodity: newProduct?.commodity,
      companyId: newProduct?.companyId,
      weightedType: newProduct?.weightedType,
      breakdownType: newProduct?.breakdownType,
      translations: newProduct?.translations,
      relatedConcepts: mapProductsConceptModelResponse(newProduct?.relatedConcepts)
    }
  )
}

export const mapProductDetail = (newProductDetail: any): ProductDetail => {
  return (
    newProductDetail && {
      id: newProductDetail.id,
      code: newProductDetail.code,
      description: newProductDetail.description,
      type: newProductDetail.type,
      currency: newProductDetail.currency,
      ...(newProductDetail.commodity && { commodity: newProductDetail.commodity }),
      ...(newProductDetail.companyId && { companyId: newProductDetail.companyId }),
      ...(newProductDetail.weightedType && { weightedType: newProductDetail.weightedType }),
      ...(newProductDetail.breakdownType && { breakdownType: newProductDetail.breakdownType }),
      lgEnabled: newProductDetail.lgEnabled
    }
  )
}

export const mapToProductTranslationArray = (
  translations: ProductTranslationModel[]
): ProductTranslation[] => {
  return translations.map(translation => mapToProductTranslation(translation))
}

export const mapToProductTranslation = (
  translation: ProductTranslationModel
): ProductTranslation => {
  return {
    id: translation.id,
    productId: translation.productId,
    language: translation.language,
    description: translation.description,
    default: translation.default
  }
}

export const mapProductsConceptModelResponse = (concepts: any[]): ProductConceptModel[] => {
  return concepts.map(concept => mapProductConceptModelResponse(concept))
}

export const mapProductConceptModelResponse = (concept: any): ProductConceptModel => {
  return {
    id: concept.id,
    conceptId: concept.conceptId,
    productId: concept.productId,
    code: concept.code,
    description: concept.description,
    conceptType: concept.conceptType,
    calculationType: concept.calculationType,
    quantityType: concept.quantityType,
    startDate: concept.startDate,
    endDate: concept.endDate,
    required: concept.required,
    conceptNotFromApiGet: false,
    relationType: concept.relationType,
    conditionType: concept.conditionType
  }
}

export const filterConceptsByRelationType = (
  concepts: ProductConceptModel[] | undefined,
  filterByRelationType: EnumTipoRelacionProductoConcepto
): ProductConceptModel[] => {
  if (concepts) {
    return concepts.filter(concept => concept.relationType === filterByRelationType)
  }
  return []
}

export const mapObligatoryConcepts = (concepts: ProductConceptModel[] | undefined) => {
  if (concepts) {
    return concepts.filter(c => c.required == true)
  }
  return []
}

export const mapOptionalConcepts = (concepts: ProductConceptModel[] | undefined) => {
  if (concepts) {
    return concepts.filter(c => c.required === false || c.required == undefined)
  }
  return []
}

export const mapTemplates = (templates: TemplateSettings[]) => {
  const templatesOnly: TemplateSettings[] = templates.filter(
    t => t.templateType === enumKeyToValue(EnumTipoConfiguracion, EnumTipoConfiguracion.Plantilla)
  )
  const templateConceptsOnly: TemplateSettings[] = templates.filter(
    t =>
      t.templateType === enumKeyToValue(EnumTipoConfiguracion, EnumTipoConfiguracion.Widget) &&
      t.templateSubType ===
        enumKeyToValue(EnumSubTipoConfiguracion, EnumSubTipoConfiguracion.Concepto)
  )

  return {
    templatesOnly,
    templateConceptsOnly
  }
}

export const mapTemplateToSelectOption = (
  templates: TemplateSettings[]
): SelectOption[] | undefined => {
  if (templates) {
    return templates.map(t => {
      return {
        value: t.id!,
        label: t.description!
      }
    })
  }
  return undefined
}

export const mapTemplateToArray = (templates: SelectOption[]): (string | number)[] => {
  if (templates) {
    return templates.map(t => t.value)
  } else return []
}

export const templateSettingsMapper = (items: any[]): TemplateSettings[] => {
  return items && items.map(templateSettingMapper)
}

export const templateSettingMapper = (item: any): TemplateSettings => {
  return (
    item && {
      id: item.id,
      templateType: enumKeyToValue(EnumTipoConfiguracion, item.templateType),
      templateSubType: enumKeyToValue(EnumSubTipoConfiguracion, item.templateSubType),
      description: item.description,
      products: item.products,
      contractType: item.contractType,
      client: item.client,
      language: enumKeyToValue(EnumIdioma, item.language),
      currentVersion: item.currentVersion,
      idDetail: item.idDetail
    }
  )
}

export const mapPriceComponentTypesToSelectOptions = (
  priceComponentsArray: PriceComponentTypeModel[]
): SelectOption[] => {
  return priceComponentsArray.map(priceComponent =>
    mapPriceComponentTypesToSelectOption(priceComponent)
  )
}

export const mapPriceComponentTypesToSelectOption = (
  priceComponent: PriceComponentTypeModel
): SelectOption => {
  return {
    value: priceComponent.id!,
    label: `${priceComponent.code} - ${priceComponent.description}`
  }
}
// export const mapResponseArrayToProductPriceModel = (
//   data: ProductPriceModel[]
// ): ProductPriceModel[] => {
//   return data.map(element => mapResponseElementToProductPriceModel(element))
// }

// export const mapResponseElementToProductPriceModel = (
//   element: ProductPriceModel
// ): ProductPriceModel => {
//   return {
//     ...element,
//     price: {
//       ...element.price,
//       commodity: enumKeyToValue(EnumCommodity, element.price.commodity),
//       priceType: enumKeyToValue(EnumPriceTypes, element.price.priceType),
//       referenceType: enumKeyToValue(EnumTipoCPrecio, element.price.referenceType)
//     }
//   }
// }

export const mapNewContractProductToProductModel = (
  newProduct: NewContractProduct | undefined
): Partial<ProductModel> => {
  if (!newProduct) {
    return {}
  }
  return {
    id: newProduct.id,
    code: newProduct.productCode,
    description: newProduct.productDescription,
    currency: newProduct.currency
  }
}

export const mapConcepts = (apiData: any[]): ConceptModifiedModel[] => {
  return apiData.map(item => {
    const price: PriceSummaryModel = {
      id: item.price?.id,
      priceType: enumKeyToValue(EnumPriceType, item.price?.priceType),
      unitPrice: item.price?.precioUnitario,
      rounding: item.price?.redondeo,
      priceCalculationType: item.price?.priceCalculationType,
      expression: item.price?.expression ?? '',
      values: [],
      coefficients: [],
      commodity: enumKeyToValue(EnumCommodity, item.price?.commodity)
    }

    return {
      id: item.id,
      description: '',
      startDate: item.price?.startDate,
      endDate: item.price?.endDate ?? '',
      masterConcept: {
        id: item.conceptId,
        code: item.conceptCode,
        description: item.description,
        conceptType: item.conceptType,
        calculationType: item.calculationType
      } as any,
      price,
      contractProduct: undefined as any,
      toll: item.toll ?? null,
      usage: item.usage ?? null,
      flow: item.flow ?? null,
      duration: item.duration ?? null,
      taxRegion: item.taxRegion ?? null,
      period: item.period ?? null
    }
  })
}
